import {
  budgetDeductRule,
  PAYMENTS_RULES,
  QUIT_RULES,
  shoppingExpenseRule,
  type Rule,
} from '@tahi/core';

/** Core rules the web app runs on dispatch. Module plans append theirs, in release order. */
export const RULES: Rule[] = [
  budgetDeductRule,
  shoppingExpenseRule,
  ...QUIT_RULES,
  ...PAYMENTS_RULES,
];
